import { Injectable } from "@angular/core";
import { NotificationService } from "@backbase/ui-ang/notification";
import { NotificationType } from "@backbase/ui-ang/notification/notification.component";

@Injectable({
    providedIn: 'root'
})
export class CustomNotificationService {
    showNotification(header: string, message: string, modifier: NotificationType) {
        this.notificationService.showNotification({
            header: header,
            message: message,
            modifier: modifier,
            dismissible: true,
            ttl: 8000
        });
    }

    constructor(
        private readonly notificationService: NotificationService
    ) { }
}